import { render, staticRenderFns } from "./PdpSparePartNumbersTab.vue?vue&type=template&id=91539d3a&scoped=true"
import script from "./PdpSparePartNumbersTab.vue?vue&type=script&lang=js"
export * from "./PdpSparePartNumbersTab.vue?vue&type=script&lang=js"
import style0 from "./PdpSparePartNumbersTab.vue?vue&type=style&index=0&id=91539d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91539d3a",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-spare-part-numbers-tab%2FPdpSparePartNumbersTab.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports